import type { SearchResponse } from "@chat-yai/shared/admin-types";
import { request } from "@/api/client";

export const searchApi = {
  query(q: string, signal?: AbortSignal) {
    const opts: Parameters<typeof request>[1] = { query: { q } };
    if (signal) opts.signal = signal;
    return request<SearchResponse>("/admin/search", opts);
  },
};
